import { SetStateAction } from 'react'
import { Popover } from '@headlessui/react'
import { BiWallet } from 'react-icons/bi'
import AlgoSymbol from 'components/AlgoSymbol'
import { classNames, truncateAddress } from 'src/helpers/utilities'
import { useJoyrideStore } from 'store/state/joyrideStore'

type MenuButtonProps = {
  setReferenceElement: React.Dispatch<SetStateAction<HTMLElement | null>>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeAccount: any
  hasActiveAccount: boolean
  walletBalance: string | null
}

export default function MenuButton({
  setReferenceElement,
  activeAccount,
  hasActiveAccount,
  walletBalance
}: MenuButtonProps) {
  const { address } = activeAccount || {}

  const runTour = useJoyrideStore((state) => state.runTour)
  const setRunTour = useJoyrideStore((state) => state.setRunTour)

  const handleMenuButtonClick = () => {
    runTour && setRunTour(false)
  }

  const renderLabel = () => {
    if (!hasActiveAccount) {
      return <span className="hidden lg:inline">Connect Wallet</span>
    }

    if (!address) {
      return <span className="hidden lg:inline">Address</span>
    }

    const addr = truncateAddress(address, { array: true })

    return (
      <span className="hidden lg:inline font-mono">
        {addr[0]}&hellip;{addr[1]}
        {walletBalance && (
          <>
            <span className="opacity-50 tracking-wider font-light">{` | `}</span>
            <span>
              <AlgoSymbol className="mx-1.5" />
              {walletBalance}
            </span>
          </>
        )}
      </span>
    )
  }

  return (
    <Popover.Button
      ref={setReferenceElement}
      onClick={handleMenuButtonClick}
      className={classNames(
        hasActiveAccount
          ? 'bg-gradient-to-r from-brand-400 to-brand-600 hover:from-brand-500 hover:to-brand-600 focus:ring-brand-500 text-white dark:from-brand-500 dark:to-brand-600 dark:hover:from-brand-400 dark:hover:to-brand-600'
          : 'bg-gray-100 hover:bg-gray-200 text-gray-900 lg:bg-gray-900 lg:hover:bg-gray-800 lg:text-white focus:ring-gray-900 dark:bg-gray-700/75 dark:text-gray-100 dark:hover:bg-gray-700',
        'inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 lg:px-4 lg:rounded-md dark:focus:ring-offset-gray-900 dark:focus:ring-gray-300'
      )}
    >
      <BiWallet className="h-6 w-6 lg:-ml-1 lg:mr-2 lg:h-5 lg:w-5" aria-hidden="true" />
      {renderLabel()}
    </Popover.Button>
  )
}
